import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Clubhouse = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.184 2.654-10.967 3.5V2.696L.39 6.47v10.025l10.2-3.258v3.441L24 12.403l-3.634-3.55zM10.592 4.929v6.592l-8.567 2.733V7.662zm9.683.367-1.85 3.9 2.542 2.467-8.75 2.791V7.871zM1.741 17.863c-.958 0-1.741.783-1.741 1.741 0 .959.783 1.742 1.741 1.742a1.74 1.74 0 1 0 0-3.483z"
  }));
});
Clubhouse.displayName = 'Clubhouse';
export var ClubhouseDimensions = {
  height: 24,
  width: 24
};